// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.illness[data-v-0122e298]{\n  width: 100%;\n  /*margin: 0 auto;*/\n  height: 29%;\n  text-align: center;\n  margin-top: 0;\n  page-break-before: always;\n}\n.illness-txt[data-v-0122e298]{\n  position:absolute;\n  font-size: 36px;\n  left: 80px;\n  top: 22px;\n  margin: 0;\n}\n.illness-pic[data-v-0122e298]{\n  width: 1002px;\n  height: 100%;\n  left: 24px;\n  top: 40px;\n}\n\n", ""]);
// Exports
module.exports = exports;
